export const INVESTOR_ACTIVIST_SHORT_SHORT = 'S';

export default {
  INVESTOR_ACTIVIST_SHORT_SHORT
};
